import { all, takeLatest } from 'redux-saga/effects'

import { FILTER_GROUP_MEMBERS } from './components/Header/components/ButtonsArea/components/FilterButton/constants'

import createGroupSaga from './sagas/createGroupSaga'
import toggleGroupStackSaga from './sagas/toggleGroupStackSaga'
import changeGroupNameSaga from './sagas/changeGroupNameSaga'
import groupStackMembersSaga from './sagas/groupStackMembersSaga'
import groupStackResizeSaga from './sagas/groupStackResizeSaga'
import deleteGroupMemberSaga from './sagas/deleteGroupMemberSaga'
import groupStackDropSaga from './sagas/groupStackDropSaga'
import groupStackExportSaga from './sagas/groupStackExportSaga'
import groupStackFilterMembersSaga from './sagas/groupStackFilterMembersSaga'

import {
    TOGGLE_GROUP_STACK,
    CREATE_NEW_GROUP,
    LOAD_GROUP_MEMBERS,
    CHANGE_GROUP_NAME,
    RESIZE_GROUP_STACK,
    DELETE_GROUP_MEMBER,
    DELETE_ALL_GROUP_MEMBERS,
    INSERT_MEMBER_TO_GROUP,
    GROUP_STACK_EXPORT_MEMBERS,
} from './constants'

export default function* groupStackSaga() {
    yield all([
        takeLatest(TOGGLE_GROUP_STACK, toggleGroupStackSaga),
        takeLatest(CREATE_NEW_GROUP, createGroupSaga),
        takeLatest(CHANGE_GROUP_NAME, changeGroupNameSaga),
        takeLatest(LOAD_GROUP_MEMBERS, groupStackMembersSaga),
        takeLatest(RESIZE_GROUP_STACK, groupStackResizeSaga),
        takeLatest(DELETE_GROUP_MEMBER, deleteGroupMemberSaga),
        takeLatest(DELETE_ALL_GROUP_MEMBERS, deleteGroupMemberSaga),
        takeLatest(INSERT_MEMBER_TO_GROUP, groupStackDropSaga),
        takeLatest(GROUP_STACK_EXPORT_MEMBERS, groupStackExportSaga),
        takeLatest(FILTER_GROUP_MEMBERS, groupStackFilterMembersSaga),
    ])
}
